"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.authSuiteFetchHelper = void 0;
var headers_1 = require("../service/headers");
var getHeaders = function (authSuiteFetchData, tokens) {
    var applicationAccessToken = tokens ? tokens.applicationAccessToken : null;
    var customRequestHeaders = authSuiteFetchData.customRequestHeaders;
    return headers_1.headersService.getHeaders(customRequestHeaders, applicationAccessToken);
};
var getRequestConfig = function (authSuiteFetchData, tokens) {
    var body = authSuiteFetchData.body, method = authSuiteFetchData.method;
    var headers = getHeaders(authSuiteFetchData, tokens);
    return {
        body: body,
        headers: headers,
        method: method,
    };
};
exports.authSuiteFetchHelper = {
    getRequestConfig: getRequestConfig,
};
